import { motion } from "framer-motion";

/* Small section-level fade + lift on scroll. Adds a calm transition between
   stacked sections so the page doesn't read as hard slabs. */
export const SectionReveal = ({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    style={{ contentVisibility: "auto", containIntrinsicSize: "1px 1200px" }}
  >
    {children}
  </motion.div>
);
